module.exports = __webpack_public_path__ + "static/ruler.ad659294b4371a63ba6a2872ea49f446.svg";